import { render, staticRenderFns } from "./block_add.vue?vue&type=template&id=2c584ebc&"
import script from "./block_add.vue?vue&type=script&lang=ts&"
export * from "./block_add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports